// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../isMonday/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var isMonday = convertToFP(fn, 1);
export default isMonday;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/isMonday/index.js
// module id = 928
// module chunks = 0